export const LOAD_SHARE_DASHBOARD_TOKEN_REQUEST = 'LOAD_SHARE_DASHBOARD_TOKEN_REQUEST';
export const LOAD_SHARE_DASHBOARD_TOKEN_SUCCESS = 'LOAD_SHARE_DASHBOARD_TOKEN_SUCCESS';
export const LOAD_SHARE_DASHBOARD_TOKEN_FAILURE = 'LOAD_SHARE_DASHBOARD_TOKEN_FAILURE';
